/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Spacer = (props) => (
  <div className={classnames(`cmp-spacer spacer-size-${props.size}`, props.className, { 'top-only-padding': props.topOnly })} style={props.style}>
    {props.children}
  </div>
);
Spacer.propTypes = {
  children: PropTypes.any,
  size: PropTypes.oneOf(['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '12', '14', '15', '16', '18', '20', '24', '40']).isRequired,
  topOnly: PropTypes.bool,
  style: PropTypes.object,
  className: PropTypes.string,
};

export default Spacer;
